/**
 * swireBilling模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const swireBilling = {
  // billing页面维度下拉框
  billingDimensionComboBox(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/billingDimensionComboBox`,params);
  },
  // billing页面近10日下拉框
  billingNearlyTenDaysComboBox(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/billingNearlyTenDaysComboBox`,params);
  },
  // 近10日花费分析图表
  costComparisonNearlyTenDaysChart(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/costComparisonNearlyTenDaysChart`,params);
  },
  // 近10日花费分析导出
  costComparisonNearlyTenDaysExport(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/costComparisonNearlyTenDaysExport`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 近10日花费分析详情
  costComparisonNearlyTenDaysParticulars(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/costComparisonNearlyTenDaysParticulars`,params);
  },
  // 维度花费图表
  dimensionCostChart(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/dimensionCostChart`,params);
  },
  // 维度花费导出
  dimensionCostExport(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/dimensionCostExport`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 维度花费详情
  dimensionCostParticulars(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/dimensionCostParticulars`,params);
  },
  // 太古S3图表
  listS3StorageLastWeek(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/listS3StorageLastWeek`,params);
  },
  // 太古S3导出
  listS3Export(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 太古S3详情
  listS3StorageDetail(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/listS3StorageDetail`,params);
  },
   // 太古S3账户
  listS3ComboBox(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/listS3ComboBox`,params);
  },
  // 月度花费图表
  monthlyCostChart(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/monthlyCostChart`,params);
  },
  // 月度花费导出
  monthlyCostExport(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/monthlyCostExport`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 月度花费详情
  monthlyCostParticulars(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/monthlyCostParticulars`,params);
  },
  // 太古花费日增长图表
  swireDailyGrowthCurveChart(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/swireDailyGrowthCurveChart`,params);
  },
  // 太古花费日增长详情
  swireDailyGrowthCurveParticulars(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/swireDailyGrowthCurveParticulars`,params);
  },
  // 太古花费日增长详情导出
  swireDailyGrowthCurveParticularsExport(params) {
    return $http.post(`${global.API_URL}/sme/swireBilling/swireDailyGrowthCurveParticularsExport`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  }
}

export default swireBilling;


// WEBPACK FOOTER //
// ./src/api/swireBilling.js